export const devs = [
    {
        "id": "1",
        "nome": "Victor Torres",
        "email": "victor.tmeloo@gmail.com",
        "foto" : require("../assets/img/Victor.jpeg"),
        "cargo": "Desenvolvedor Front-end",
        "github": "https://github.com/VictorTmelo",
        "linkedin": "https://www.linkedin.com/in/victor-torres-de-melo/"
    },
    {
        "id": "2",
        "nome": "Renato Vidal",
        "email": "renatovidal__@hotmail.com",
        "foto" : require("../assets/img/Renato.jpeg"),
        "cargo": "Desenvolvedor Full-stack",
        "github": "https://github.com/Renato0402",
        "linkedin": "https://www.linkedin.com/in/renato-vidal-moura-85a319265/"
    },
    {
        "id": "3",
        "nome": "Álbero Ítalo",
        "email": "playerghost13@gmail.com",
        "foto" : require("../assets/img/Albero.jpg"),
        "cargo": "Desenvolvedor Full-stack",
        "github": "https://github.com/PlayerGhost",
        "linkedin": "https://www.linkedin.com/in/playerghost/"
    },
    {
        "id": "4",
        "nome": "Anderson Karl",
        "email": "andersonlkarl@gmail.com",
        "foto" : require("../assets/img/Anderson.jpeg"),
        "cargo": "Desenvolvedor Back-end",
        "github": "https://github.com/Artoshk",
        "linkedin": "https://www.linkedin.com/in/anderson-karl-34a3a7223/"
    },
    {
        "id": "5",
        "nome": "Divaldo Júnior",
        "email": "divaldojr9@gmail.com",
        "foto" : require("../assets/img/Divaldo.jpg"),
        "cargo": "Desenvolvedor Front-end",
        "github": "https://github.com/DivaldoJr1001",
        "linkedin": "http://www.linkedin.com/in/divaldo-aderaldo-88397a189"
    },
    {
        "id": "6",
        "nome": "J. Augusto Marinho",
        "email": "ze.augustomarinho@gmail.com",
        "foto" : require("../assets/img/Augusto.jpeg"),
        "cargo": "Product Designer",
        "behance": "https://www.behance.net/joseaugustomarinho",
        "linkedin": "https://www.linkedin.com/in/joseaugustomarinho/"
    }
]